import { render, staticRenderFns } from "./property-upsert-form-items.vue?vue&type=template&id=0c3c8464&"
import script from "./property-upsert-form-items.vue?vue&type=script&lang=ts&"
export * from "./property-upsert-form-items.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports